import { useField } from 'formik';
import { FC } from 'react';
import React from 'react';
import { NumberInput } from './NumberInput.js';
import { Props as NumberInputProps } from './NumberInput.js';

type Props = Omit<NumberInputProps, 'value' | 'onChange'> & {
  name: string;
};

export const FormNumberInput: FC<Props> = ({ name, ...props }) => {
  const [field, meta, helpers] = useField(name);
  return (
    <NumberInput
      {...props}
      value={field.value}
      onChange={helpers.setValue}
      onBlur={field.onBlur}
      hasError={Boolean(meta.touched && meta.error)}
      errorMessage={meta.error}
    />
  );
};
